<template>
  <section class="p-2">
    <v-card class="pa-4">
      <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
        <v-sheet
          class="v-sheet--offset ms-4 pt-1 text-center"
          elevation="0"
          outlined
          width="90px"
        >
          <p class="font-weight-bold">
            <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
            >Filters
          </p>
        </v-sheet>
        <v-form ref="filter" v-model="valid" class="px-2">
          <v-row class="px-2">
            <v-col cols="12" lg="3" sm="6" xs="12">
              <v-autocomplete
                v-model="filterList.partner_id"
                class="rounded"
                label="Partner"
                dense
                outlined
                :items="partner_list"
                :rules="FieldRequired('Partner')"
                item-text="txt"
                item-value="val"
                placeholder="Partner"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" lg="3" sm="6" xs="12">
              <v-autocomplete
                v-model="filterList.txn_type"
                class="rounded"
                label="Transaction Type"
                dense
                outlined
                :items="[
                  {
                    txt: 'Individual',
                    val: 'IND',
                  },
                  {
                    txt: 'Business',
                    val: 'BUS',
                  },
                ]"
                :rules="FieldRequired('Transaction Type')"
                item-text="txt"
                item-value="val"
                placeholder="Transaction Type"
              ></v-autocomplete>
            </v-col>
            <v-btn
              depressed
              @click="getAllRates()"
              class="mr-2 mt-1"
              color="primary"
              small
              >Get Results
            </v-btn>
          </v-row>
        </v-form>
      </v-card>
      <v-data-table
        fixed-header
        height="55vh"
        :headers="dessertHeaders"
        :items="RatesSummary"
        show-group-by
        group-by="country"
        :search="search"
        dense
        item-key="rate_id"
      >
        <template v-slot:group.header="{ group, headers, toggle }">
          <td :colspan="headers.length" @click="toggle">
            <span class="mx-5 font-weight-bold">{{ group }}</span>
          </td>
        </template>
        <template v-slot:item.payment_mode="{ item }">
          {{ item.payment_mode.value }}
        </template>
        <template v-slot:item.currency_code="{ item }">
          {{ item.partner_settlement_currency?`${item.currency_code}/${item.partner_settlement_currency}`:item.currency_code }}
        </template>
        <template v-slot:item.update_status="{ item }">
          <v-icon
            v-if="item.update_status && item.update_status == 1"
            color="success"
            title="Rate Updated"
            >mdi-check-circle</v-icon
          >
          <v-icon
            v-if="item.update_status && item.update_status == 2"
            color="error"
            title="Rate not updated"
            >mdi-close-circle</v-icon
          >
          <v-icon
            v-if="item.update_status && item.update_status == 3"
            color="white"
            class="bg-sync-icon"
            title="Same Rate"
          >
            mdi-sync-off</v-icon
          >
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex">
            <v-icon
              small
              @click="updateRate(item)"
              title="Update Rate"
              color="primary"
              class="mr-2"
            >
              mdi-content-save-edit-outline
            </v-icon>
            <!-- <v-icon
              small
              title="view logs"
              @click="rateLogs = true"
              color="primary"
              class="mr-2"
            >
              mdi-information-outline
            </v-icon> -->
            <v-btn
              v-if="item.is_api_partner"
              depressed
              x-small
              class="text-capitalize"
              color="primary"
              @click="updateSpecificRate(item)"
              ><v-icon x-small> mdi-reload</v-icon>Fetch Rate
            </v-btn>
          </div>
        </template>

        <template v-slot:top>
          <div class="d-flex mt-3">
            <v-btn
              depressed
              v-if="hide_fetchallrates"
              small
              class="text-capitalize me-2 ms-2 mt-2 text-decoration-none"
              color="primary"
              @click="fetchAllRates()"
              ><v-icon small> mdi-reload</v-icon>Fetch All Rates</v-btn
            >
            <v-spacer> </v-spacer>
            <v-spacer> </v-spacer>
            <v-btn
              depressed
              @click="downloadExcelsheet"
              color="primary"
              small
              class="me-5 mt-2"
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              hide-details
              class="me-4 mb-3"
              dense
              clearable
            ></v-text-field>
          </div>
        </template>
      </v-data-table>
      <v-dialog persistent v-model="rateLogs" width="1200">
        <rateScheduleLogsVue @closeRateLogs="rateLogs = false" />
      </v-dialog>
      <v-dialog persistent v-model="approvalRate" width="400">
        <v-card>
          <v-toolbar color="#050048" dark flat dense>
            <span>Approval</span>
            <v-spacer></v-spacer>
            <v-btn depressed icon @click="approvalRate = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text
            ><h5 class="text-center font-weight-bold mt-2">
              Are you sure you want update the rate?
            </h5></v-card-text
          >
          <v-divider class="pa-0 ma-0"></v-divider>
          <v-card-actions class="ma-0 pt-0">
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              small
              class="text-capitalize me-2 ms-2 mt-5 text-decoration-none"
              color="primary"
              @click="ApproveRate()"
              ><v-icon small>mdi-content-save-plus-outline</v-icon>
              Update
            </v-btn>
            <v-btn
              depressed
              small
              class="text-capitalize me-2 ms-2 mt-5 text-decoration-none"
              color="primary"
              outlined
              @click="approvalRate = false"
              ><v-icon small>mdi-close-circle-outline</v-icon>cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="updaterateDialog" width="500">
        <template v-if="updaterateDialog">
          <UpdateScheduleRate
            :selectedUpdateRate="selectedUpdateRate"
            @closeRateLogs="updaterateDialog = false"
            @reloadData="getAllRates"
          />
        </template>
      </v-dialog>
      <OverlayPageVue :showOverlay="loader" />
    </v-card>
  </section>
</template>

<script>
import partnerService from "@/services/partnerService/partnerService.js";
import setupService from "@/services/SetupService/setupService.js";
import { FieldRequired } from "@/utils/validation.js";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import alerts from "@/mixins/alerts";
import rateScheduleLogsVue from "./rateScheduleLogs.vue";
import UpdateScheduleRate from "./UpdateScheduleRate.vue";
export default {
  mixins: [alerts],
  name: "FX Cost Schedule",
  data() {
    return {
      FieldRequired,
      search: "",
      loader: false,
      showDialog: false,
      updaterateDialog: false,
      approvalRate: false,
      rateLogs: false,
      valid: true,
      selectedUpdateRate: null,
      hide_fetchallrates: false,
      editedIndex: -1,
      partner_list: [],
      partner_obj: [],
      selectedData: [],
      selectedApprovedRate: {},
      filterList: {
        country: null,
        txn_type: null,
      },

      dessertHeaders: [
        {
          text: "Id",
          sortable: false,
          value: "id",
          groupable: false,
        },
        {
          text: "Country",
          sortable: false,
          value: "country",
          groupable: false,
        },
        { text: "Payment mode", value: "payment_mode", groupable: false },
        { text: "Currency", value: "currency_code", groupable: false },
        { text: "Cost Rate", value: "buy_rate", groupable: false },
        { text: "Selling Rate", value: "sell_rate", groupable: false },
        { text: "Last Updated Date", value: "modified_date", groupable: false },
        { text: "Last Sync", value: "last_fetch_date", groupable: false },
        { text: "Status", value: "update_status", groupable: false },
        {
          text: "Action",
          value: "action",
          sortable: false,
          width: "200px",
          groupable: false,
        },
      ],

      RatesSummary: [],
    };
  },
  components: {
    OverlayPageVue,
    rateScheduleLogsVue,
    UpdateScheduleRate,
  },
  watch: {
    "RatesDetails.payout_country"(val) {
      this.dropdown.country_objs.map((ele) => {
        if (ele.iso_alpha3 === val) {
          this.RatesDetails.currency = ele.currency_code;
        }
      });
    },
  },
  mounted() {
    this.getMainRecList();
  },
  computed: {
    formtitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
  },
  methods: {
    isApiPartner(val) {
      const selected_partner = this.partner_obj.filter(
        (ele) => ele.partner_id == val
      );
      this.hide_fetchallrates = !!(
        selected_partner && selected_partner[0].partner_id
      );
    },
    async fetchAllRates() {
      this.loader = true;
      try {
        const response = await setupService.getallfetchcostratespartner(
          this.filterList
        );
        if (response.data.status_code == 200) {
          this.getAllRates();
          this.stoploader();
        } else {
          this.RatesSummary = [];
          this.showAlertError(response.data.message);
          this.stoploader();
        }
      } catch (error) {
        this.RatesSummary = [];
        this.stoploader();
        this.showAlertError("Something Went wrong!");
        console.error(error);
      }
    },
    async updateSpecificRate(item) {
      console.log(item);
      this.loader = true;
      try {
        const response = await setupService.getlatestschedulerate({
          partner_id: this.filterList.partner_id,
          country_code: item.country_code,
          txn_type: this.filterList.txn_type,
          payment_mode: item.payment_mode.value_code,
        });
        if (response.data.status_code === 200) {
          this.approvalRate = true;
          if (response.data.data && response.data.data[0].rate) {
            this.selectedApprovedRate = { ...item };
            if (response.data && response.data.data[0].rate) {
              this.selectedApprovedRate.updated_rate =
                response.data.data[0].rate;
            }
          }

          this.stoploader();
        } else {
          this.showAlertError(response.data.message);
          this.stoploader();
        }
      } catch (error) {
        this.stoploader();
        console.error(error);
      }
    },
    async ApproveRate() {
      this.loader = true;
      if (
        this.selectedApprovedRate &&
        this.selectedApprovedRate.updated_rate &&
        this.selectedApprovedRate.updated_rate !=
          this.selectedApprovedRate.buy_rate
      ) {
        const payload = {
          buy_rate: this.selectedApprovedRate.updated_rate,
          sell_rate: this.selectedApprovedRate.updated_rate,
          previous_balance: this.selectedApprovedRate.previous_balance,
          current_balance: this.selectedApprovedRate.current_balance,
          previous_rate: this.selectedApprovedRate.previous_rate,
          current_rate: this.selectedApprovedRate.current_rate,
        };
        try {
          const responseData = await setupService.updateFxCostRate(
            this.selectedApprovedRate.id,
            payload
          );
          if (responseData.data.status_code === 200) {
            this.approvalRate = false;
            this.getAllRates();
            this.stoploader();
            this.showAlertSuccess(responseData.data.message);
          } else {
            this.stoploader();
            this.showAlertError(responseData.data.message);
          }
        } catch (e) {
          this.stoploader();
          this.showAlertError("fetch data Something went wrong");
          console.error(e);
        }
      } else {
        this.approvalRate = false;
        this.getAllRates();
        this.stoploader();
      }
    },
    updateRate(item) {
      this.selectedUpdateRate = item;
      this.updaterateDialog = true;
    },
    async getAllRates() {
      const validate = this.$refs.filter.validate();
      if (validate) {
        this.loader = true;
        try {
          const response = await setupService.getallcostratespartner(
            this.filterList
          );
          if (response.data.status_code == 200) {
            this.RatesSummary = response.data.data;
            this.isApiPartner(this.filterList.partner_id);
            console.log("Rates Data", this.RatesSummary);
            this.stoploader();
          } else {
            this.RatesSummary = [];
            this.showAlertError(response.data.message);
            this.stoploader();
          }
        } catch (error) {
          this.RatesSummary = [];
          this.stoploader();
          this.showAlertError("Something Went wrong!");
          console.error(error);
        }
      }
    },

    async getMainRecList() {
      try {
        const response = await partnerService.getMainRecList();
        if (response.status === 200) {
          this.partner_list = response.data.data.map((i) => {
            if (i.partner_id != 2)
              return { txt: i.partner_name, val: i.partner_id };

            this.partner_obj = response.data.data;
          });
        }
      } catch (e) {
        console.error(e);
        this.partner_list = [];
      }
    },

    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },

    async downloadExcelsheet() {
      if (this.RatesSummary) {
        this.exportToExcel(
          this.dessertHeaders,
          this.RatesSummary,
          "RatesSummary"
        );
      }
    },

    openDialog() {
      this.editedIndex = -1;
      this.showDialog = true;
    },

    closeDialog() {
      this.showDialog = false;
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";

.width-anchor {
  width: 200px !important;
}

.required:after {
  content: " *";
  color: red;
}
.apexcharts-toolbar {
  display: none !important;
}
.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.bord-color {
  border-radius: 10px;
}
.bg-sync-icon {
  border: 1px solid orange;
  border-radius: 50%;
  background-color: orange;
  font-size: 19px;
}
</style>
